import { Button, Drawer, Flex, Group, Loader, Title, useMantineTheme } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import MeetingContact from 'components/shared/Meeting/MeetingList/MeetingCard/MeetingContact';
import Text from 'components/shared/Text';
import { ROUTES } from 'configs/routes';
import { useMeetingUpdateDrawerModal } from 'stores/global/RootStore/MeetingUpdateDrawerModal';
import { createFullName } from 'utils/createFullName';
import { useDevices } from 'utils/devices';

import Detail from './Detail';

import s from './MeetingUpdateDrawer.module.scss';

const MeetingUpdateDrawer: React.FC = () => {
  const theme = useMantineTheme();
  const { isPhone } = useDevices();
  const navigate = useNavigate();
  const meetingUpdateDrawerModal = useMeetingUpdateDrawerModal();
  const { close, isOpen, updateMeeting, updateLoadingStage, isError, isTouched, clientModel, loadingStage } =
    meetingUpdateDrawerModal;

  const handleClientClick = React.useCallback(() => {
    if (clientModel.value) {
      navigate(ROUTES.lk.clients.detail.create(clientModel.value.id));
      close();
    }
  }, [clientModel.value, navigate, close]);

  if (!isOpen) {
    return null;
  }

  const isLoading = loadingStage.isLoading;

  return (
    <Drawer.Root
      opened={isOpen}
      onClose={close}
      position="right"
      size={isPhone ? '100%' : 'md'}
      offset={isPhone ? 0 : theme.spacing.lg}
      radius={isPhone ? 0 : 'md'}
    >
      <Drawer.Overlay />
      <Drawer.Content>
        <Drawer.Body className={s.root} p={0}>
          <Group wrap="nowrap" align="flex-start" justify="space-between" className={s.root__header}>
            <Title size={isPhone ? 'h3' : 'h2'} fw={600}>
              Изменить встречу
            </Title>
            <Drawer.CloseButton onClick={close} size={32} icon={<IconX size={24} />} />
          </Group>
          <div className={s.root__content}>
            {isLoading ? (
              <Flex justify="center" align="center" h="100%">
                <Loader />
              </Flex>
            ) : (
              <Flex direction="column" gap="xl" w="100%">
                {clientModel.value && (
                  <Flex p="md" className={s.root__drawer}>
                    <MeetingContact
                      title="Клиент"
                      fullName={createFullName(clientModel.value)}
                      phone={clientModel.value.phone}
                      onClick={handleClientClick}
                    />
                  </Flex>
                )}
                {clientModel.value && <Detail />}
              </Flex>
            )}
          </div>
          <div className={s.root__footer}>
            <Button
              fullWidth
              onClick={updateMeeting}
              disabled={isError || !isTouched}
              loading={updateLoadingStage.isLoading}
            >
              <Text size="lg" c={isError || !isTouched ? 'gray' : 'white'}>
                Сохранить изменения
              </Text>
            </Button>
          </div>
        </Drawer.Body>
      </Drawer.Content>
    </Drawer.Root>
  );
};

export default observer(MeetingUpdateDrawer);
